
import React from 'react'
import TopNav, { TYPE_TopNav } from './TopNav/TopNav.tsx'
import SideNav from '@/component/layout/SideNav/SideNav.tsx'
import TestModeBanner from '@/component/testMode/TestModeBanner.tsx'

type IProps = {
    className?: string;
    showTopNav?: boolean
    typeTopNav?: TYPE_TopNav
    showSideNav?: boolean
    hideTestModeBanner?: boolean
    mapScreen?: boolean
    children?: any
}

/*
    탑 네비게이션 한번에 컨트롤 @showTabNav (상단 고정)
    사이드 네비게이션 @showSideNav (좌측, 펼침 240 · 레일 72, 1023px 이하는 상단바 ☰ 서랍)
    지도 화면 @mapScreen (화면 높이 고정. 767px 이하에서 나머지 화면은 문서 전체가 스크롤)

 */
const PageConfig: React.FunctionComponent<IProps> = ({
    className,
    showTopNav,
    showSideNav,
    typeTopNav = TYPE_TopNav.DEFAULT,
    hideTestModeBanner,
    mapScreen,
    children
}) => {
    const isWorkspace = Boolean(showSideNav)
    const showTestModeBanner = showTopNav && typeTopNav === TYPE_TopNav.DEFAULT && !hideTestModeBanner

    return (
        <div
            className={`page-frame flex h-screen h-[100dvh] flex-col relative ${isWorkspace ? 'app-shell' : ''} ${mapScreen ? 'map-screen' : ''} ${className || ''} overflow-hidden`}
        >
            {showTopNav && <TopNav className={''} type={typeTopNav} />}
            {showTestModeBanner && <TestModeBanner />}
            <main className={`page-frame__body flex min-h-0 flex-1 overflow-hidden ${isWorkspace ? 'app-shell__body' : ''}`}>
                {showSideNav && <SideNav className={'app-shell__side flex-none overflow-y-auto md:hidden'} />}
                <div className={`page-frame__content min-w-0 min-h-0 flex-1 overflow-y-auto ${isWorkspace ? 'app-shell__main' : ''}`}>
                    {children}
                </div>
            </main>
        </div>
    )
}

export default PageConfig
